/** Variables públicas de Vite (se incrustan en el build: nunca secretos). */
export const env = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ?? '',
  appEnv: (import.meta.env.VITE_ENV as 'local' | 'qa' | 'prod' | undefined) ?? 'local',
  recaptchaSiteKey: (import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined) ?? '',
  cdnUrl: (import.meta.env.VITE_CDN_URL as string | undefined) ?? '',
  /** Beta por invitación (plan §17.1): muestra el aviso de versión beta. */
  beta: import.meta.env.VITE_BETA === 'true',
  /** PHP legacy (durante la beta, platform.; tras el corte, legacy-platform.). */
  legacyUrl: (
    (import.meta.env.VITE_LEGACY_URL as string | undefined) ?? 'https://platform.consaludenarm.com'
  ).replace(/\/$/, ''),
  sentryDsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? '',
};
